import {
    APPLY_STATUS_FAILURE,
    APPLY_STATUS_SUCCESS,
    APPLY_STATUS_PENDING,
    CHECK_APPLY_VALUE_INIT,
    CHECK_APPLY_VALUE_FAILURE,
    CHECK_APPLY_VALUE_SUCCESS, CLEAR_APPLY_FIELD
} from "../actions/ApplyFieldActions";

const initialState = {};

export default function ApplyFieldReducer(state = initialState, action) {
    switch (action.type) {
        case CHECK_APPLY_VALUE_INIT:
            return {
                ...state,
                [action.payload.name]: {
                    value: action.payload.value,
                    status: APPLY_STATUS_PENDING,
                    data: {},
                    error: action.payload.error,
                }
            }

        case CHECK_APPLY_VALUE_FAILURE:
            return {
                ...state,
                [action.payload.name]: {
                    value: action.payload.value,
                    status: APPLY_STATUS_FAILURE,
                    data: {},
                    error: action.payload.error,
                }
            }

        case CHECK_APPLY_VALUE_SUCCESS:
            return {
                ...state,
                [action.payload.name]: {
                    value: action.payload.value,
                    status: action.payload.status,
                    data: action.payload.data,
                    error: action.payload.error,
                }
            }

        case CLEAR_APPLY_FIELD:
            return {
                ...state,
                [action.payload.name]: undefined,
            }
    }

    return state
}
